/**
 * Expose isArray
 */

module.exports = isArray['default'] = isArray

/**
 * isArray
 */

function isArray (val) {
  return Array.isArray(val)
}



//////////////////
// WEBPACK FOOTER
// ./~/@f/is-array/lib/index.js
// module id = ./node_modules/@f/is-array/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons